<div class="selected-pages-toolbar" [class.visible]="internalVisible" [class.drawer-closed]="!drawerOpened">
  <div class="toolbar-content">
    <!-- Header Section -->
    <div class="toolbar-header">
      <mat-checkbox
        class="selection-checkbox"
        [checked]="true"
        aria-label="Clear selected pages"
        (click)="onClearSelection()"
        matTooltip="Click to clear selection"
        matTooltipPosition="below"
      ></mat-checkbox>
      <div class="selection-info">
        <span class="selection-title">{{ getSelectedPagesText() }}</span>
        <span class="selection-subtitle">Pages: {{ getSelectedPageNumbers() }}</span>
      </div>
    </div>

    <!-- Actions Section -->
    <div class="toolbar-actions">
      <!-- Cancel Button -->
      <button
        mat-button
        class="cancel-button"
        (click)="onCancel()"
        matTooltip="Cancel and clear selection"
        matTooltipPosition="below"
      >
        Cancel
      </button>

      <!-- Re-ingest Pages Button -->
      <button
        mat-raised-button
        color="primary"
        class="reingest-button"
        (click)="onReingestPages()"
        matTooltip="Re-process selected pages (PDF extraction, text analysis, title extraction)"
        matTooltipPosition="below"
      >
        <mat-icon>refresh</mat-icon>
        <span>Re-ingest Pages</span>
      </button>
    </div>
  </div>
</div>
